import { Fragment } from "react";
import { Skeleton } from "@material-ui/lab";
import useScreen from "../../providers/screen";
import Card from "../../components/card";
import {
  Col,
  Row,
  LoadingCard,
  LoadingCardContainer,
  ContainerQuantity,
} from "./style";

const Loading = () => {
  const { screen } = useScreen();

  return (
    <>
      <LoadingCardContainer>
        <Skeleton
          className="transform-y-0 my-2"
          animation="wave"
          width="100%"
          height={40}
        />
        {[0, 1, 2].map((item) => (
          <Fragment key={item}>
            <Card className={`p-2 mb-2 ${!screen?.isDesktop && "mx-1"}`}>
              <Row className="row no-gutters">
                <Col className="col-4">
                  <Skeleton
                    className="mx-auto"
                    variant="circle"
                    animation="wave"
                    width={100}
                    height={100}
                  />
                </Col>
                <Col className="col-8">
                  <LoadingCard>
                    <Skeleton
                      className="transform-y-0 mb-2 d-block"
                      animation="wave"
                      width={80}
                      height={10}
                    />
                    <Skeleton
                      className="transform-y-0 mb-2 mt-1"
                      animation="wave"
                      width={180}
                      height={10}
                    />
                    <Skeleton
                      className="transform-y-0 mb-2 mt-1"
                      animation="wave"
                      width={90}
                      height={10}
                    />
                    <ContainerQuantity>
                      <Skeleton
                        className="transform-y-0 d-inline-block"
                        variant="circle"
                        animation="wave"
                        width={25}
                        height={25}
                      />
                    </ContainerQuantity>
                  </LoadingCard>
                </Col>
              </Row>
            </Card>
          </Fragment>
        ))}
        <Skeleton
          className="transform-y-0 my-2"
          animation="wave"
          width="100%"
          height={40}
        />
        {[0].map((item) => (
          <Fragment key={item}>
            <Card className="p-2 mb-2">
              <Row className="row no-gutters">
                <Col className="col-4">
                  <Skeleton
                    className="mx-auto"
                    variant="circle"
                    animation="wave"
                    width={100}
                    height={100}
                  />
                </Col>
                <Col className="col-8">
                  <LoadingCard>
                    <Skeleton
                      className="transform-y-0 mb-2 d-block"
                      animation="wave"
                      width={80}
                      height={10}
                    />
                    <Skeleton
                      className="transform-y-0 mb-2 mt-1"
                      animation="wave"
                      width={180}
                      height={10}
                    />
                    <Skeleton
                      className="transform-y-0 mb-2 mt-1"
                      animation="wave"
                      width={90}
                      height={10}
                    />
                    <ContainerQuantity>
                      <Skeleton
                        className="transform-y-0 d-inline-block"
                        variant="circle"
                        animation="wave"
                        width={25}
                        height={25}
                      />
                    </ContainerQuantity>
                  </LoadingCard>
                </Col>
              </Row>
            </Card>
          </Fragment>
        ))}
      </LoadingCardContainer>
    </>
  );
};

export default Loading;
